export const selectOrganizationId = (state) => state.organization.id;
export const selectOrganizationPlanId = (state) => state.organization.planId;
export const selectShowtimeDomain = (state) =>
  state.organization.showtimeDomain;
